import React, { useContext } from 'react'
import { DashboardContext } from '../../../context/DashboardContext'
import { formatDateHMMSS } from '../../../utils/formatDate'
import PropTypes from 'prop-types'

export function NeedTooltip({ id, content, participantId, whoSaidIt, startTime, referent }) {
  const { openNoteDialog, getParticipant } = useContext(DashboardContext)

  return (
    <div className="w-[300px] text-left flex flex-col gap-[6px]">
      <p className="font-bold text-[16px] font-['Manrope'] capitalize">{referent}</p>
      <p className="font-normal text-[14px] font-['Manrope']">{content}</p>
      <div className="flex items-center">
        <p className="font-semibold text-[14px] font-['Manrope']">
          {participantId ? getParticipant(participantId)?.name : whoSaidIt} @ {formatDateHMMSS(startTime)}・
        </p>
        <button
          className="text-linkBlue font-semibold text-[14px] font-['Manrope']"
          onClick={() => openNoteDialog('need', id)}
        >
          See Need ❯
        </button>
      </div>
    </div>
  )
}

NeedTooltip.propTypes = {
  id: PropTypes.string,
  content: PropTypes.string,
  participantId: PropTypes.string,
  whoSaidIt: PropTypes.string,
  startTime: PropTypes.number,
}
